import {
  FETCH_MESSAGE_BANNERS_ERROR,
  FETCH_MESSAGE_BANNERS_SUCCESS,
  PUSH_MESSAGE_BANNERS_SUCCESS,
  DISMISS_MESSAGE_BANNER,
  CLEAR_MESSAGE_BANNER,
  CLEAR_MESSAGE_BANNERS,
  CLEAR_ALL_MESSAGES_BY_AUTHOR,
} from './messageBannerActions';

const messageBannerReducers = {
  [FETCH_MESSAGE_BANNERS_ERROR]: state => {
    return {
      ...state,
      messages: [],
    };
  },
  [FETCH_MESSAGE_BANNERS_SUCCESS]: (state, { payload }) => {
    var ids = new Set(state.messages.map(d => d.messageId));
    return {
      ...state,
      messages: [
        ...state.messages,
        ...payload.filter(d => !ids.has(d.messageId)),
      ],
    };
  },
  [PUSH_MESSAGE_BANNERS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      messages: [...state.messages, payload[0]],
    };
  },
  [DISMISS_MESSAGE_BANNER]: (state, { payload }) => {
    return {
      ...state,
      dismissed: [...state.dismissed, payload],
    };
  },
  [CLEAR_MESSAGE_BANNER]: (state, { payload }) => {
    let [messageId] = [...payload];
    let messageIndex;
    if (state.messages) {
      messageIndex = state.messages.findIndex(
        message => message.messageId === messageId
      );
    }
    state.messages.splice(messageIndex, 1);
    return state;
  },
  [CLEAR_ALL_MESSAGES_BY_AUTHOR]: (state, { payload }) => {
    return {
      ...state,
      messages: payload,
    };
  },
  [CLEAR_MESSAGE_BANNERS]: state => {
    return {
      ...state,
      messages: [],
    };
  },
};

export default {
  name: 'messageBanner',
  reducers: messageBannerReducers,
  persist: {
    key: 'messageBanner',
    whitelist: ['dismissed'],
  },
};
